'use strict';

class IComparable {
	compare(other) {
		return 0;
	}
}

module.exports = IComparable;